import React from 'react';
import Loader from '../../ui/Loader';
import { ErrorJumbotron } from '../../ui/ErrorJumbotron';
import Singleton from '../../core/singleton';

export const ProductsList = props => (props.displayedShopProducts.length > 0)
    ? <div className="row ProductsList">
        {
            props.displayedShopProducts.map(
                (product, index) => {
                    const Categories = () => <>
                        {
                            product.categories.map((categorie, index) => <button onClick={() => props.setSearchValue(categorie)} key={index} className="badge badge-secondary category-selector" >{categorie}</button>)
                        }
                    </>
                    return <div className={`product-card ${(props.displayMode === "grid") ? 'col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2' : 'col-12'}`} key={index}>
                        <div className="card mb-3">
                            <div className="card-header d-flex">
                                {
                                    (product.brand !== null && product.brand !== "") &&
                                    <button
                                        onClick={() => props.setSearchValue(product.brand)}
                                        className="align-items-center p-0 btn btn-naked d-flex justify-content-between w-100 brand-selector">{product.brand}
                                    </button>
                                }

                                <button
                                    className="badge badge-primary stock-badge-btn"
                                    onClick={() => props.editAndShowStockOf(product)}>
                                    {(product.stock && product.stock.quantity !== null) ? product.stock.quantity : <i className="fas fa-infinity"></i>}
                                </button>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">{product.title}</h5>
                                <p className="card-text"><Categories /></p>
                            </div>
                        </div>
                    </div>
                }
            )
        }
    </div>
    : (props.searchCriteria !== "" && (props.displayedShopProducts.length < 1))
        ? <ErrorJumbotron message={Singleton.getInstance().getTradByKey('no_product_for_search')} />
        : (props.displayedShopProducts.length === 0)
            ? <ErrorJumbotron message={Singleton.getInstance().getTradByKey('nothing_to_see')} />
            : <Loader />